import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import {
  PapiSettingsInitAccount,
  PapiSettingsInitBrowsing,
  PapiSettingsInitGdpr,
  PapiSettingsInitNotifications,
  PapiSettingsInitPromotion,
  PapiSettingsInitSecurity,
} from '@wix/da-papi-types';

export const action = createAction(`${reduxKey}.XXX`, () => ({}));

export const initMyAccountPage = createAction(
  `${reduxKey}.INIT_MY_ACCOUNT_PAGE`,
  (data: Omit<PapiSettingsInitAccount, 'session'>) => ({ data })
);
export const initBrowsingPage = createAction(
  `${reduxKey}.INIT_BROWSING_PAGE`,
  (data: Omit<PapiSettingsInitBrowsing, 'session'>) => ({ data })
);
export const initSecurityPage = createAction(
  `${reduxKey}.INIT_SECURITY_PAGE`,
  (data: Omit<PapiSettingsInitSecurity, 'session'>) => ({ data })
);
export const initNotificationsPage = createAction(
  `${reduxKey}.INIT_NOTIFICATIONS_PAGE`,
  (data: Omit<PapiSettingsInitNotifications, 'session'>) => ({ data })
);
export const initPromosPage = createAction(
  `${reduxKey}.INIT_PROMOS_PAGE`,
  (data: Omit<PapiSettingsInitPromotion, 'session'>) => ({ data })
);
export const initPersonalDataPage = createAction(
  `${reduxKey}.INIT_PERSONAL_DATA_PAGE`,
  (data: Omit<PapiSettingsInitGdpr, 'session'>) => ({ data })
);

// TODO: Add deactivation init
/**
export const initDeactivationPage = createAction(
  `${reduxKey}.INIT_DEACTIVATION_PAGE`,
  (data: Omit<PapiSettingsDeactivationInit, 'session'>) => ({
    data,
  })
);
*/

export const initDeactivationStatus = createAction(
  `${reduxKey}.INIT_DEACTIVATION_STATUS`,
  (status: { canReactivate?: boolean; timeUntilReactivation?: number }) => ({
    status,
  })
);
